import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="volumes" className="defer-paint w-full scroll-mt-16 bg-sand py-10 sm:py-14" aria-labelledby="volumes-heading" data-id="element-204" data-mp="cm526r4zghlj">
      <div className="mx-auto max-w-4xl px-6" data-id="element-205" data-mp="3g4py6yqp1cy6">
        <SectionHeading eyebrow="📚 The core 6-volume library" title={<span id="volumes-heading" data-id="element-207" data-mp="3c4fi2t96t65l">150 lessons. Zero planning.</span>} lead="Six volumes covering every level and every part of your session. Open any volume to see the problem it solves and what’s inside." data-id="element-206" data-mp="3g5hiveir5q9o" />

        <ol className="mt-8 space-y-2.5" data-id="element-208" data-mp="3l39lp3kxqwsn">
          {volumes.map((volume, index) => {
          const isOpen = openIndex === index;
          return <li key={volume.code} className={`rounded-3xl border bg-shell transition-colors duration-150 ease-out ${isOpen ? 'border-navy/40' : 'border-line'}`} data-id="element-209" data-mp="2xcnc37va94gj" data-mpi={index}>
                <h3 data-id="element-210" data-mp="29epeaaklucvl">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-center gap-4 rounded-3xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy sm:px-6" data-id="element-211" data-mp="29f8law8pvguu">
                    <span className="inline-flex h-11 w-11 shrink-0 flex-col items-center justify-center rounded-xl bg-navy-deep font-display text-sm font-extrabold text-lime" aria-hidden="true" data-id="element-212" data-mp="1qgwdpexgef1d">
                      {volume.code}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-213" data-mp="20dixe0e1n01t">
                      <span className="block font-display text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-214" data-mp="24gnufnfcu9j2">
                        {volume.name}
                        <span className="font-medium text-stone" data-id="element-215" data-mp="3bw21oaf0l3rt">
                          {' '}
                          — {volume.subtitle}
                        </span>
                      </span>
                      <span className="mt-0.5 block font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-navy" data-id="element-216" data-mp="1gsnkmhjrg66p">
                        {volume.count}
                      </span>
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-stone transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-217" data-mp="1ksnz226v0hdr" />
                  </button>
                </h3>

                <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-218" data-mp="t21cyrdo4nx8">
                  <div className="overflow-hidden" data-id="element-219" data-mp="120vgz2tbwgkt">
                    <div className="border-t border-line px-5 py-5 sm:px-6" data-id="element-220" data-mp="1203hvi0iw0ps">
                      <p className="font-sans text-[0.9rem] leading-relaxed text-stone" data-id="element-221" data-mp="eaj195rudfjo">
                        <span className="font-semibold text-ink" data-id="element-222" data-mp="9cptw9esyfht">
                          The problem solved:{' '}
                        </span>
                        {volume.intro}
                      </p>
                      <ul className="mt-5 space-y-3" data-id="element-223" data-mp="2psm93lskxcam">
                        {volume.focus.map(item => <li key={item.title} className="border-l-2 border-lime pl-4 font-sans text-[0.85rem] leading-relaxed" data-id="element-224" data-mp="2c1he4x05p86m">
                            <span className="block font-semibold text-ink" data-id="element-225" data-mp="2gwmyhrdwuesl">
                              {item.title}
                            </span>
                            <span className="block text-stone" data-id="element-226" data-mp="38p5kyiurpeav">
                              {item.detail}
                            </span>
                          </li>)}
                      </ul>
                      <p className="mt-5 border-t border-line pt-4 font-display text-[0.95rem] font-bold leading-snug text-navy" data-id="element-227" data-mp="2zofttsggcc3h">
                        {volume.result}
                      </p>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}